export enum ApplicationName {
    FlexworkerPortal = 135,
    RelationPortal = 140,
}
